import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../store/actions/profileActions';
import '../../assets/css/style.css';

const ProfileCampus = () => {
    const profile = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();
    
    const handleChange = (newValue) => {
        dispatch(action.collectProfileData({...profile, universityInfo: newValue}));
    }
    
    return (
        <div className="uni-form">
            <div className="uni-select-grp">
                <select 
                    value={profile.universityInfo.campus} 
                    onChange={(e) => handleChange({...profile.universityInfo, campus: e.target.value})} 
                    name="campus" id="campus" className="uni-select">
                        <option value="campus">Campus</option>
                        <option value="APB">Auckland Park - Bunting (APB)</option>
                        <option value="APK">Auckland Park - Kingsway (APK)</option>
                        <option value="DFC">Doornfontein (DFC)</option>
                        <option value="SWC">Soweto (SWC)</option>
                </select>

                <select 
                    value={profile.universityInfo.faculty} 
                    onChange={(e) => handleChange({...profile.universityInfo, faculty: e.target.value})} 
                    name="faculty" id="faculty" className="uni-select">
                        <option value="faculty">Faculty</option>
                        <option value="CBE">College of Business and Economics</option>
                        <option value="FADA">Faculty of Art, Design and Architecture</option>
                        <option value="FEBE">Faculty of Engineering & the Built Environment</option>
                        <option value="FHS">Faculty of Health Sciences</option>
                        <option value="FH">Faculty of Humanities</option>
                        <option value="FL">Faculty of Law</option>
                        <option value="FS">Faculty of Science</option>
                </select>
            </div>
        </div>
    );
};

export default ProfileCampus;